/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_After_2Inputs */

const en_landing_after_2 = /** @type {(inputs: Landing_After_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-optimized formatting that passes screening`)
};

const de_landing_after_2 = /** @type {(inputs: Landing_After_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-optimierte Formatierung, die das Screening besteht`)
};

const fr_landing_after_2 = /** @type {(inputs: Landing_After_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise en forme optimisée pour les ATS qui passe les filtres`)
};

const es_landing_after_2 = /** @type {(inputs: Landing_After_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato optimizado para ATS que pasa el filtro`)
};

const it_landing_after_2 = /** @type {(inputs: Landing_After_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formattazione ottimizzata per l'ATS che supera lo screening`)
};

const nl_landing_after_2 = /** @type {(inputs: Landing_After_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-geoptimaliseerde opmaak die de screening doorstaat`)
};

const pl_landing_after_2 = /** @type {(inputs: Landing_After_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatowanie zoptymalizowane pod ATS, które przechodzi screening`)
};

const fi_landing_after_2 = /** @type {(inputs: Landing_After_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-optimoitu muotoilu, joka läpäisee seulan`)
};

const da_landing_after_2 = /** @type {(inputs: Landing_After_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-optimeret formatering der kommer gennem screening`)
};

const sv_landing_after_2 = /** @type {(inputs: Landing_After_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-optimerad formatering som klarar gallringen`)
};

/**
* | output |
* | --- |
* | "ATS-optimized formatting that passes screening" |
*
* @param {Landing_After_2Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_after_2 = /** @type {((inputs?: Landing_After_2Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_After_2Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_after_2(inputs)
	if (locale === "fr") return fr_landing_after_2(inputs)
	if (locale === "es") return es_landing_after_2(inputs)
	if (locale === "it") return it_landing_after_2(inputs)
	if (locale === "nl") return nl_landing_after_2(inputs)
	if (locale === "pl") return pl_landing_after_2(inputs)
	if (locale === "fi") return fi_landing_after_2(inputs)
	if (locale === "da") return da_landing_after_2(inputs)
	if (locale === "sv") return sv_landing_after_2(inputs)
	return en_landing_after_2(inputs)
});